function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "facebook_svg__login-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 266.89 266.89"
  }, props), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#4267b2"
    },
    width: 266.89,
    height: 266.89,
    rx: 14.73,
    ry: 14.73
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M184.15 266.89V163.54h34.69l5.16-40.28h-39.85V97.54c0-11.66 3.24-19.61 20-19.61h21.33v-36a285.42 285.42 0 0 0-31.08-1.59c-30.75 0-51.81 18.77-51.81 53.24v29.71h-34.82v40.28h34.78v103.32Z"
  }));
};
export default SvgFacebook;